module.exports = __webpack_public_path__ + "img/myketDark.2d5db36c.svg";